import { PositionVariant } from 'domain/bubble';

export const getPosTool = (pos: PositionVariant, max: number, self: number, p = 0) => {
  switch (pos) {
    case 'start':
      return 0 + 10 * p;
    case 'center':
      return max / 2 - self / 2;
    case 'end':
      return max - self - 10 * p;
    default:
      return 0;
  }
};
